<div class="backModal enCierre">
  <div class="close closeModal">
    <a (click)="close()" title="cerrar">
      <span class="cross"></span>
      <span class="sr-only">cerrar</span>
    </a>
  </div>
  <div class="aviso facturacion">
    <div class="tituloSearch">{{ 'TITULO_SIMPE' | translate }}</div>
    <div class="tituloSearch">
      {{ 'LABEL_IMPORTE_PAGAR_SIMPE' | translate }} 
      {{ (data || 0) | myCurrency : divisaSimboloDecimal : divisaDecimales : divisaPosicion 
        : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }} 
      {{ 'LABEL_SIMPE_MOVIL' | translate }}
    </div>
    <div class="simpeInputWrap" [formGroup]="sinpeForm">
      <!-- <div class="pagoRow">
        <div class="tit-form-group">
          <label for="localizador"> IMPORTE A PAGAR </label>
        </div>
        <div class="form-group-wrap">
          <div class="form-group">
            <input [readonly]="true" type="text" class="form-control" id="localizador" />
          </div>
        </div>
      </div> -->

      <div class="pagoRow">
        <div class="tit-form-group">
          <label for="tipoCedula">{{ 'LABEL_TIPO_CEDULA' | translate }}</label>
        </div>
        <div class="form-group-wrap">
          <div class="form-group">
            <select formControlName="tipoCedula" class="form-control" id="tipoCedula">
              <option *ngFor="let tipo of tipoIdentificacionSINPE.options" [value]="tipo.value">
                {{ tipo.nombre }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="pagoRow form-group-nocurrency">
        <div class="tit-form-group">
          <label for="fecha"> {{ 'LABEL_NUMERO_DOCUMENTO' | translate }} </label>
        </div>
        <div class="form-group-nocurrency">
          <input formControlName="numDocumento" type="text" class="form-control"/>
          <input
            type="button"
            class="pagar aceptar"
            value="{{ 'CONSULTAR' | translate }}"
            (click)="consultarPago()"
          />
        </div>
      </div>

      <div *ngIf="mensajeError" class="error-message">
        {{ mensajeError }}
      </div>

      <div  *ngIf="operacionesEncontradas.length > 0">
        <perfect-scrollbar class="scroll-area">
          <table>
            <thead>
              <tr>
                <th colspan="7" class="titulo-operaciones">
                  {{ 'LABEL_OPERACIONES_ENCONTRADAS' | translate }}
                </th>
              </tr>
              <tr>
                <th>{{ 'LABEL_FECHA_RECIBIDO' | translate }}</th>
                <th>{{ 'LABEL_REFERENCIA_BANCO' | translate }}</th>
                <th>{{ 'LABEL_TELEFONO' | translate }}</th>
                <th>{{ 'LABEL_ID_CLIENTE' | translate }}</th>
                <th>{{ 'LABEL_NOMBRE_CLIENTE' | translate }}</th>
                <th>{{ 'LABEL_MONTO' | translate }}</th>
                <th>{{ 'LABEL_ACCION' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let pago of operacionesEncontradas">
                <td>{{ pago.fechaRecibido }}</td>
                <td>{{ pago.codReferenciaBanco }}</td>
                <td>{{ pago.numTelefonoOrigen }}</td>
                <td>{{ pago.idClienteOrigen }}</td>
                <td>{{ pago.nombreCliente }}</td>
                <td>{{ ( pago.monto || 0) | myCurrency : divisaSimboloDecimal : divisaDecimales : divisaPosicion 
                  : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }} </td>
                <td><button (click)="usarPago(pago)" class="pagar aceptar" >{{ pago.utilizado ? ('LABEL_QUITAR' | translate) : ('LABEL_UTILIZAR' | translate) }}</button></td>
              </tr>
            </tbody>
          </table>
        </perfect-scrollbar>
      </div>

      <div  class="total-container"  *ngIf="operacionesEncontradas.length > 0">
        <div class="pagoRow">
          <div class="tit-form-group">
            <label for="totalPagar"> {{ 'TOTAL A PAGAR' | translate }}</label>
          </div>
          <div class="form-group-wrap">
            <div class="form-group">
              <input id="totalPagar" type="text" class="form-control" [value]="totalPagarFormateado" readonly />
            </div>
          </div>
        </div>
      </div>

      <div class="faturacion-fila">
        <div class="ticket-info">
          <div class="inputControl botones">
            <button 
            type="button" 
            class="pagar aceptar" 
            (click)="aceptar()" 
            [disabled]="botonAceptarDeshabilitado">
            {{ 'ACEPTAR' | translateV2 }}
          </button>
            <button type="button" class="cancelar" (click)="cancelar()">
              {{ 'CANCELAR' | translateV2 }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
